/**
 * Build absolute API URLs for public (no-auth) pages like brief-digest feedback.
 * When the SPA is served from a different host than the API, set REACT_APP_API_URL
 * at build time (e.g. https://app.showstop.ai) so fetch hits the real backend.
 */
export function publicApiUrl(path) {
  const rel = path.startsWith('/') ? path : `/${path}`;
  const base = (process.env.REACT_APP_API_URL || '').trim().replace(/\/$/, '');
  return base ? `${base}${rel}` : rel;
}
